import gql from 'graphql-tag'

export const DEFAULT_CATEGORIES_VALUES = {
  name: ''
}

export const fragments = {
  category: gql`
    fragment categoryFields on Category {
      id
      name
      createdAt
      updatedAt
    }
  `
}

export const GET_ALL_CATEGORIES_QUERY = gql`
  query categories($page: Int) {
    categories(page: $page, limit: 20) {
      collection {
        ...categoryFields
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
  ${fragments.category}
`

export const GET_ALL_CATEGORIES_WITH_CHILDREN_QUERY = gql`
  query categories($page: Int) {
    categories(page: $page, limit: 20) {
      collection {
        ...categoryFields
        styles {
          id
          name
          products {
            id
            name
            frontMediumUrl
            backMediumUrl
          }
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
  ${fragments.category}
`

export const GET_CATEGORY_QUERY = gql`
  query categories($id: Int!) {
    category(id: $id) {
      ...categoryFields
    }
  }
  ${fragments.category}
`
